import 'angular';
import '../document-viewer/right_panel.html';

angular.module('GorillaBoy.directives')
    .directive('documentViewerRightPanel', () => {
        return {
            restrict: 'E',
            controller: 'DocumentRightPanelController',
            templateUrl: './document-viewer/right_panel.html'
        }
    });